import React from 'react';
import { Eye, Edit, Trash2 } from 'lucide-react';

const RowActions = ({
  onView,
  onEdit,
  onDelete,
  showView = true,
  showEdit = true,
  showDelete = true,
  disableView = false,
  disableEdit = false,
  disableDelete = false,
  children,
  className = '',
}) => {
  const stopPropagation = (event) => event.stopPropagation();

  const buttonClass =
    'p-2 rounded-lg transition-colors disabled:opacity-40 disabled:cursor-not-allowed';

  return (
    <div
      className={`flex items-center justify-end gap-1 flex-nowrap ${className}`}
      onClick={stopPropagation}
    >
      {showView && (
        <button
          type="button"
          onClick={onView}
          disabled={disableView}
          title="Voir"
          className={`${buttonClass} text-blue-600 hover:bg-blue-50`}
        >
          <Eye className="w-4 h-4" />
        </button>
      )}
      {showEdit && (
        <button
          type="button"
          onClick={onEdit}
          disabled={disableEdit}
          title="Modifier"
          className={`${buttonClass} text-amber-600 hover:bg-amber-50`}
        >
          <Edit className="w-4 h-4" />
        </button>
      )}
      {showDelete && (
        <button
          type="button"
          onClick={onDelete}
          disabled={disableDelete}
          title="Supprimer"
          className={`${buttonClass} text-red-600 hover:bg-red-50`}
        >
          <Trash2 className="w-4 h-4" />
        </button>
      )}
      {children}
    </div>
  );
};

export default RowActions;
